module.exports = ".user-form .form-field-outer {\n  width: 280px; }\n\n.user-form .mat-radio-button {\n  margin-right: 12px; }\n"